import "./GameForm.css";
import { useGame } from "../api/copenhunt/v1/copenhunt_rbt_react";
import React from "react";
import { GameMode } from "../api/copenhunt/v1/copenhunt_pb";

export interface GameFormData {
  durationMinutes: number;
  durationSeconds: number;
  teamCount: number;
  locationDelaySeconds: number;
  pingIntervalSeconds: number;
  numExtraPingsForHunters: number;
  mode: GameMode;
}

const GameForm: React.FC<{
  gameId: string;
  handleGameCreation: () => void;
}> = ({ gameId, handleGameCreation }) => {
  const { mutators } = useGame({ id: gameId });

  const [formData, setFormData] = React.useState<GameFormData>({
    durationMinutes: 10,
    durationSeconds: 0,
    teamCount: 4,
    locationDelaySeconds: 300000000,
    pingIntervalSeconds: 120,
    numExtraPingsForHunters: 5,
    mode: GameMode.NORMAL,
  });

  function handleInputChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: !Number.isNaN(value) ? Number(value) : value,
    });
  }

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    onSubmit(formData);
  }

  const onSubmit = async (formData: GameFormData) => {
    const { aborted, response } = await mutators.create({
      gameDurationSeconds:
        formData.durationMinutes * 60 + formData.durationSeconds,
      teamCount: formData.teamCount,
      locationDelaySeconds: formData.locationDelaySeconds,
      pingIntervalSeconds: formData.pingIntervalSeconds,
      numExtraPingsForHunters: formData.numExtraPingsForHunters,
      mode: formData.mode,
    });
    if (aborted !== undefined) {
      console.warn(aborted.error.getType());
      console.warn(aborted.message);
    }

    if (response) {
      console.log("Response", response);
      handleGameCreation();
    }
  };

  return (
    <div className="form-container">
      <div className="form">
        <form onSubmit={handleSubmit}>
          <div>
            <label>
              Game duration
              <div className="time-inputs">
                <input
                  type="number"
                  name="durationMinutes"
                  value={formData.durationMinutes}
                  onChange={handleInputChange}
                />
                <span>m</span>
                <input
                  type="number"
                  name="durationSeconds"
                  value={formData.durationSeconds}
                  onChange={handleInputChange}
                />
                <span>s</span>
              </div>
            </label>
          </div>
          <label>
            Game Mode
            <select
              name="mode"
              value={formData.mode}
              onChange={handleInputChange}
            >
              <option value={GameMode.NORMAL}>Normal</option>
              <option value={GameMode.DISTANCES_ONLY}>Distances only</option>
            </select>
          </label>
          <label>
            Number of teams
            <input
              type="number"
              name="teamCount"
              value={formData.teamCount}
              onChange={handleInputChange}
            />
          </label>
          <label
            title="How often the map should ping everyone's location"
          >
            Ping Interval (seconds)
            <input
              type="number"
              name="pingIntervalSeconds"
              value={formData.pingIntervalSeconds}
              onChange={handleInputChange}
            />
          </label>
          <label title="How many extra pings the hunter team starts with">
            Extra pings for hunters
            <input
              type="number"
              name="numExtraPingsForHunters"
              value={formData.numExtraPingsForHunters}
              onChange={handleInputChange}
            />
          </label>
          {/* <label
            title="How much out of date a player's location can be at most, regardless of pings"
          >
            Maximum location out-of-date-ness (seconds)
            <input
              type="number"
              name="locationDelaySeconds"
              value={formData.locationDelaySeconds}
              onChange={handleInputChange}
            />
          </label> */}
          <button className="buttonEnabled" type="submit">
            Create Game!
          </button>
        </form>
      </div>
    </div>
  );
};

export default GameForm;
